/* ============================================================
   SPORTIVE CART ENHANCEMENTS
   Quick-add from upsell row inside cart drawer
   ============================================================ */

(function () {
  'use strict';

  function initCartUpsell() {
    document.addEventListener('click', function (e) {
      const btn = e.target.closest('[data-sportive-upsell-add]');
      if (!btn) return;

      const variantId = btn.dataset.sportiveUpsellAdd;
      if (!variantId || btn.disabled) return;

      btn.disabled = true;
      const originalText = btn.textContent;
      btn.textContent = '...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          btn.textContent = '✓ Added!';
          btn.style.background = '#2e7d32';

          // Trigger Dawn's cart refresh
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

          // Fallback: reload cart drawer via fetch
          setTimeout(function () {
            const cartDrawerEl = document.querySelector('cart-drawer');
            if (cartDrawerEl && typeof cartDrawerEl.renderContents === 'function') {
              fetch('/cart?sections=cart-drawer')
                .then(function (r) { return r.json(); })
                .then(function (data) {
                  if (data['cart-drawer']) {
                    const parser = new DOMParser();
                    const newDoc = parser.parseFromString(data['cart-drawer'], 'text/html');
                    const newDrawer = newDoc.querySelector('#CartDrawer');
                    const currentDrawer = document.querySelector('#CartDrawer');
                    if (newDrawer && currentDrawer) {
                      currentDrawer.innerHTML = newDrawer.innerHTML;
                    }
                  }
                })
                .catch(function () {});
            }
          }, 800);
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = originalText;
        });
    });
  }

  document.addEventListener('DOMContentLoaded', initCartUpsell);
})();
